import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import authUtils from 'utils/auth';
import dxApi from 'services/dxApi';
import { closeIcon } from 'assets/icons';
import { CircularProgress } from '@mui/material';

const MonthlyGoals = ({
  adminAddGoals,
  isAddGoalsRequesting,
  isGoalsAdded,
  loadPrevoiusGoals,
  adminPreviousgoals,
  isPreviousGoalsLoading,
}) => {
  const currentYear = new Date().getFullYear();
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const currentMonthIndex = new Date().getMonth();
  const filteredMonths = months.slice(currentMonthIndex);
  const [selectedMonth, setSelectedMonth] = useState(currentMonthIndex + 1);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [goalNumber, setGoalNumber] = useState('');
  const [goals, setGoals] = useState([]);

  const admin_access_token = authUtils.getAdminToken();
  const locations = [
    {
      id: 6,
      name: 'Marin',
    },
    {
      id: 7,
      name: 'Oakland',
    },
    {
      id: 5,
      name: 'SF Castro',
    },
    {
      id: 1,
      name: 'SF Embarcadero',
    },
    {
      id: 4,
      name: 'SF Fillmore',
    },
    {
      id: 2,
      name: 'SF Mid Market',
    },
    {
      id: 3,
      name: 'SF SOMA',
    },
    {
      id: 8,
      name: 'SF Transbay',
    },
  ];
  const previewHeading = ['Month', 'Year', 'Location', 'Goal', 'Action'];
  const historyHeading = ['Month', 'Year', 'Location', 'Goal', 'Created Date', 'Active'];
  const years = [];
  const targetYear = 2100;
  for (let year = currentYear; year <= targetYear; year++) {
    years.push(year);
  }

  const DateFormatter = dateString => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}-${day}-${year}`;
  };

  const handleMonthChange = event => {
    setSelectedMonth(parseInt(event.target.value));
  };

  const handleYearChange = event => {
    setSelectedYear(parseInt(event.target.value));
  };

  const handleLocationChange = event => {
    setSelectedLocation(event.target.value);
  };

  const handleGoalValueChange = event => {
    const inputValue = event.target.value;
    if (/^\d*$/.test(inputValue)) {
      setGoalNumber(inputValue);
    }
  };

  const handleAddGoalClick = () => {
    if (selectedMonth && selectedYear && selectedLocation && goalNumber) {
      const newGoal = {
        month: selectedMonth,
        year: selectedYear,
        location: +selectedLocation,
        goal: +goalNumber,
      };
      const index = goals.findIndex(
        item =>
          item.month === selectedMonth &&
          item.year === selectedYear &&
          item.location === +selectedLocation
      );
      if (index !== -1) {
        // if newGoal have same existing month, year and location, it update existing object with new goal
        const updatedData = goals.map((item, i) => (i === index ? newGoal : item));
        setGoals(updatedData);
      } else {
        setGoals([...goals, newGoal]);
      }
      setSelectedMonth(currentMonthIndex + 1);
      setSelectedYear(currentYear);
      setSelectedLocation(selectedLocation);
      setGoalNumber('');
    } else {
      alert('Please fill out all fields.');
    }
  };

  const handleDeleteGoal = id => {
    setGoals(prev => {
      return prev.filter((_, index) => {
        return index !== id;
      });
    });
  };

  const handleSaveClick = () => {
    adminAddGoals(goals);
  };

  useEffect(() => {
    if (isGoalsAdded) {
      setSelectedLocation('');
      setGoals([]);
      loadPrevoiusGoals(0);
    }
  }, [isGoalsAdded]);

  useEffect(() => {
    dxApi.setAuthTokenToHeader(admin_access_token);
    loadPrevoiusGoals(+selectedLocation);
  }, [selectedLocation]);

  return (
    <>
      <div className={`${styles.wrapper}`}>
        <div className={styles.textDiv}>
          <p className={styles.text}>Enter Your Monthly Goals Here:</p>
        </div>
        <hr className={styles.divider} />
        <div className={styles.innerContainer}>
          <div className={styles.inputContainer}>
            <div className={styles.inputDiv}>
              <p className={styles.label}>Enter Month:</p>
              <select
                value={selectedMonth}
                onChange={handleMonthChange}
                className={styles.select}
              >
                {filteredMonths.map((month, index) => {
                  return (
                    <option key={index + 1} value={currentMonthIndex + index + 1}>
                      {month}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className={styles.inputDiv}>
              <p className={styles.label}>Enter Year:</p>
              <select
                value={selectedYear}
                onChange={handleYearChange}
                className={styles.select}
              >
                {years.map(year => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <div className={styles.inputDiv}>
              <p className={styles.label}>Enter Location:</p>
              <select
                value={selectedLocation}
                onChange={handleLocationChange}
                className={styles.select}
              >
                <option value={''}>Select</option>
                {locations.map(location => (
                  <option key={location.id} value={location.id}>
                    {location.name}
                  </option>
                ))}
              </select>
            </div>
            <div className={styles.inputDiv}>
              <p className={styles.label}>Enter Goal:</p>
              <input
                className={styles.select}
                type="number"
                value={goalNumber}
                onChange={handleGoalValueChange}
              />
            </div>
            <div className={styles.inputDiv}>
              <button className={styles.addButton} onClick={handleAddGoalClick}>
                Add Goal
              </button>
            </div>
          </div>
        </div>
        <div className={styles.labelsContainer}>
          <p
            style={{
              textTransform: 'capitalize',
              fontWeight: 'bold',
              marginLeft: '5%',
            }}
          >
            Preview:
          </p>
          <p
            style={{
              textTransform: 'capitalize',
              fontWeight: 'bold',
              marginRight: '5%',
            }}
          >
            History:
          </p>
        </div>
        <div className={styles.tablesContainer}>
          <div className={styles.tableContainer}>
            <table>
              <thead>
                <tr>
                  {previewHeading.map((head, headID) => (
                    <th key={headID}>{head}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!goals.length ? (
                  <tr>
                    <td colSpan="5">No Goals Available</td>
                  </tr>
                ) : (
                  goals.map((goal, index) => (
                    <tr key={index}>
                      <td>{months[goal.month - 1]}</td>
                      <td>{goal.year}</td>
                      <td>{locations.find(({ id }) => id === goal.location).name}</td>
                      <td>{goal.goal}</td>
                      <td>
                        <img
                          alt=""
                          onClick={() => handleDeleteGoal(index)}
                          className={styles.closeIcon}
                          src={closeIcon}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className={styles.tableContainer}>
            <table>
              <thead>
                <tr>
                  {historyHeading.map((head, headID) => (
                    <th key={headID}>{head}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {isPreviousGoalsLoading ? (
                  <tr>
                    <td colSpan="6">
                      <CircularProgress size={18} style={{ color: '#FE5000' }} />
                    </td>
                  </tr>
                ) : adminPreviousgoals?.data?.length ? (
                  adminPreviousgoals?.data?.map((goal, index) => (
                    <tr key={index}>
                      <td>{months[goal.month - 1]}</td>
                      <td>{goal.year}</td>
                      <td>{goal.location}</td>
                      <td>{goal.goal}</td>
                      <td>{DateFormatter(goal.createddate)}</td>
                      <td>{goal.isActive ? 'True' : 'False'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">No History Available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className={styles.saveBtnDiv}>
          <button
            className={
              !goals.length || isAddGoalsRequesting ? styles.disabled : styles.saveButton
            }
            onClick={handleSaveClick}
            disabled={!goals.length || isAddGoalsRequesting}
          >
            {isAddGoalsRequesting ? (
              <CircularProgress size={15} style={{ color: '#FE5000' }} />
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default MonthlyGoals;
